import Vue from 'vue'
import App from './App'
import router from '@/router/router'
import 'lib-flexible'
import AMap from 'vue-amap';
import VueClipboard from 'vue-clipboard2';
Vue.config.productionTip = false

import '@/style/iconfont/iconfont.css';

Vue.use(AMap);
Vue.use(VueClipboard)


// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: 'ab5f10a7dea8cdc8bd2db88fdc29070c',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation','AMap.CitySearch']
});



/* eslint-disable no-new */
export const main = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js